import {
  useDashboardPeriodFetch,
  useDashboardPeriodParams,
  type DashboardPeriodFetchState,
} from './useDashboardPeriod'
import type { RangeKey } from '@dataTypes/dashboard.types'
import {
  getCaseAcceptanceOverview,
  type CaseAcceptanceOverviewResult,
} from '@services/api/dashboard/case-acceptance.api'

export function useCaseAcceptanceOverview(
  range: RangeKey,
  date: string,
  enabled = true,
  queued = false,
): DashboardPeriodFetchState<CaseAcceptanceOverviewResult> {
  const queryParams = useDashboardPeriodParams(range, date)
  return useDashboardPeriodFetch(queryParams, getCaseAcceptanceOverview, {
    enabled,
    queued,
  })
}
